module.exports = __webpack_public_path__ + "static/media/logSelected.72b645e5.svg";